import React from 'react';

const STYLES = `bg-dark-fill-blue border
border-solid border-dark-border-blue
color-grey text-center py-8 px-6 mb-6 rounded`;

export function EmptyInteractions() {
  return (
    <div
      className={STYLES}
      data-test-element="structured-interactions-empty"
    >
      No Interactions
    </div>
  );
}
